import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const BOND_DISPUTE_SOURCES_B = [
  {
    sourceId: "bond-dispute-source-wear",
    topicId: "rental-bond-disputes",
    title: "Fair wear and tear versus damage in rental properties",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/fair-wear-and-tear-versus-damage-rental-properties",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 fair wear and tear와 negligent·intentional damage의 구분 및 주요 item examples를 확인",
    reviewStatus: "live_verified",
    claimScope: "bond damage claim에서 ordinary deterioration와 tenant-caused damage 구분",
    followUp: "item age, initial condition, useful life, repair scope와 actual loss evidence 확인",
  },
  {
    sourceId: "bond-dispute-source-condition",
    topicId: "rental-bond-disputes",
    title: "Rental property condition reports",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/rental-property-condition-reports",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 entry·exit condition report, timestamped photos와 dispute evidence 역할을 확인",
    reviewStatus: "live_verified",
    claimScope: "tenancy 시작·종료 상태 비교와 bond evidence",
    followUp: "signed report, dissent comments, photos·video metadata와 inspection invitation 확인",
  },
  {
    sourceId: "bond-dispute-source-resolution",
    topicId: "rental-bond-disputes",
    title: "Resolving residential tenancy disputes",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/resolving-residential-tenancy-disputes",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 Fair Trading resolution 범위, bond dispute의 NCAT 경로와 bond payout 후 current time limit를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW tenancy dispute negotiation·Fair Trading·NCAT 경로와 일반 time limits",
    followUp: "bond-specific Notice of Claim due date와 section 175 application limit를 우선 확인",
  },
  {
    sourceId: "bond-dispute-source-ncat-orders",
    topicId: "rental-bond-disputes",
    title: "Tenancy and social housing orders",
    publisher: "NSW Civil and Administrative Tribunal",
    url: "https://ncat.nsw.gov.au/case-types/housing-and-property/tenancy/tenancy-and-social-housing-orders.html",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NCAT 공식 본문에서 Residential Tenancies Act section 175 rental bond payment order, claim particulars·amount·evidence와 6-month payout limit를 확인",
    reviewStatus: "live_verified",
    claimScope: "NCAT rental bond orders, applicant information과 supporting documents",
    followUp: "current application form, fee, respondent details, section number와 hearing directions 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of BOND_DISPUTE_SOURCES_B) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
